module.exports = __webpack_public_path__ + "fonts/bda729d.eot";